/**
 * 稿件池
 * created by lei lei
 *
 */
import React, {Component} from 'react';
import PropTypes from 'prop-types';
import {Tabs, Button, Select, Col, TreeSelect, Input, Pagination, Popover, Popconfirm, message, Empty, Dropdown, Menu,Icon } from "antd";
import SelectManuscriptPool from "../components/manuscriptPool/SelectManuscriptPool"
import {connect} from "react-redux";
import {Scrollbars} from "react-custom-scrollbars";
import SpacerBlock from "../components/spacerBlock/SpacerBlock";
import ManuscriptPoolItem from "../components/manuscriptPool/ManuscriptPoolItem";
import ManuscriptTable from "../components/manuscriptPool/ManuscriptTable";
import PublishedMedia from "../components/manuscriptPool/PublishedMedia";
import RelationTaskDetail from "../components/manuscriptPool/RelationTaskDetail";
import RelationSelectTopicDetail from "../components/manuscriptPool/RelationSelectTopicDetail";
import *as actions from "../../actions/manuscriptPool"
import * as utils from "../../utils/index"
import {HEADER_HEIGHT} from "../../constants";
import * as Actions from "../../actions/originalManuscript";
import {
    shrinNavigateStauts, updataNavigateData,
    updateNavigateLevel2Data,
} from "../../actions";
import card from '../../view/components/manuscriptPool/img/card2.png'
import otherCard from '../../view/components/manuscriptPool/img/otherCard.png'
import list from '../../view/components/manuscriptPool/img/list2.png'
import otherList from '../../view/components/manuscriptPool/img/otherList.png'

const {Search} = Input;
const {TabPane} = Tabs;

class ManuscriptPool extends Component {
    static defaultProps = {};
    static propTypes = {};

    constructor(props) {
        super(props);
        this.actions = actions;
        this.state = {
            selectKey: '1',//上面的大筛选
            typeKey: '1',//类别，状态筛选
            searchValue: '',//搜索文字
            page: 1,//当前页
            size: 10,//每页条数,
            dataList: [],//数据源
            listTotal: 0,
            popoverList: [],
            currentItemClick: {},//底部按钮当前点击数据
            topRedNum: 0,
            showType:"list",   //展示类型
            cardChecked:false,
            listChecked:true,
            isShow:false
        }
    }

    componentWillMount() {
    }

    componentDidMount() {
        this.TypeChange()
    }

    TypeChange() {
        window.loading&&window.loading.show();
        if (this.state.selectKey === '1') {
            //获取原创稿件。。。
            this.originalStoryList();
        }
        //每次更新红色角标数
        this.getMyHandle()

    }

    getMyHandle() {
        let body = {
            start: this.state.page,
            size: this.state.size,
            type: 'toDoList'
        };
        let topRedNum = 0;
        this.actions.originalStoryList(body, data => {
            if (data.count) {
                topRedNum = data.count;
            }
            this.setState({
                topRedNum: topRedNum,
            });


        })
    }

    originalStoryList() {
        let body = {
            start: this.state.page,
            size: this.state.size,
        };
        switch (this.state.typeKey) {
            case "1":
                break;
            case "2":
                body.type = 'my';
                break;
            case "3":
                body.type = 'toDoList';
                break;
            case "4":
                body.statusName = '草稿';
                break;
            case "5":
                body.type = 'process';
                break;
            case "6":
                body.type = 'publish';
                break;
            case "7":
                body.statusName = '弃用';
                break;

        }
        if (this.state.searchValue) {
            body.queryStr = this.state.searchValue
        }
        let dataList = [];
        let listTotal = 0;
        this.actions.originalStoryList(body, data => {
            window.loading&&window.loading.hide();
            if (data && data.data) {
                dataList = data.data;
                dataList.forEach(item => {
                    item.checked = false;
                });
                listTotal = data.count;
            }
            this.setState({
                dataList: dataList,
                listTotal: listTotal,
            });
            setTimeout(() => {
                this.scrollRef && this.scrollRef.scrollToTop();
            });
        })
    }

    getMenu = (item) => {
        return(
            <Menu>
                <Menu.Item>
                   <span onClick = { () =>{ this.itemDownload(item)}}>压缩包</span>
                </Menu.Item>
                <Menu.Item>
                <span  onClick = { () =>{ window.open(`/cm-sites/pms/printHtmlDetail.html?resourceId=${item.resourceId}&download=true`,'_blank');}}>文档</span>
                </Menu.Item>
            </Menu>
        )
    }
    getMoreMenu= (item) => {
        return(
            <Menu>
                {
                    item.map((i,index)=>{
                        return(
                            <Menu.Item key={index}>
                   <span onClick = {i.onClick}>
                       {
                           i.title==="下载稿件"?
                           <div id="downloadmenu" style={{
                            fontsize: 15, color: '#0050B3',cursor: 'pointer',marginRight:"10px"
                        }}>
                            <Dropdown overlay={this.getMenu(item)} arrow placement="topCenter" getPopupContainer={() => document.getElementById('downloadmenu')}><b>下载稿件</b></Dropdown>
                        </div>
                           :i.title
                       }
                       </span>
                </Menu.Item>
                        )
                
                    })
                }
                
            </Menu>
        )
    }


     // 选中类型
     checkedList=()=>{
        this.setState({
            showType:"list",
            listChecked:true,
            cardChecked:false,
            isShow:false
        })
    }
    checkedCard=()=>{
        this.setState({
            showType:"block",
            cardChecked:true,
            listChecked:false,
            isShow:true
        })
    }

     //渲染底部按钮
     renderBtn(submitStatusName, item, newSecondSelectColor,i) {
        let account = this.props.currentUser.account;
        let mediaCodes = this.props.currentUser.mediaCodes;
        let operateType=[];
        operateType.push({title:"打印",onClick:() => {window.open(`/cm-sites/pms/printHtmlDetail.html?resourceId=${item.resourceId}`,'_blank')}})
        operateType.push({title:"下载稿件",onClick:() => {}})
        if(mediaCodes.length > 0 &&(submitStatusName==='提交至拟发平台'||submitStatusName==='审核通过'||submitStatusName==='提交至媒体'|| submitStatusName === '已发布')){
            operateType.push({title:"拾取至",onClick:() => {this.getCopyStoryMediaConllection(item);}})
        }
        operateType.push({title:"预览",onClick:() => {this.review(item)}})
        if(account === item.submitter && (item.statusName === '草稿' || item.statusName === '弃用')){
            operateType.push({title:"删除",onClick:() => {this.deleteItem(item)}})
        }
        if(account === item.submitter && (item.interviewId === 0 )){
            if(item.statusName === '审核未通过' || item.statusName === '弃用'|| item.statusName === '审核通过'){

            }else{
                operateType.push({title:"关联任务",onClick:() => {
                        this.setState({currentItemClick: item});
                        this.SelectManuscriptPool.showTask({
                            taskTitle: '关联任务',
                            topBtn: false
                        })
                    }})
            }
        }
        if(account === item.submitter && (item.statusName === '草稿' || item.statusName === '弃用') &&(item.interviewId > 0 )){
            operateType.push({title:"取消关联任务",onClick:() => {
                this.cancelTaask(item)
            }})
        }
        if(account === item.submitter&&(item.statusName !== '弃用')){
            if(item.topicSelectionId === 0){
                operateType.push({title:"关联选题",onClick:() => {
                    this.setState({currentItemClick: item});
                    this.SelectManuscriptPool.showTask({
                        taskTitle: '关联选题',
                        topBtn: false
                    })
                }})
            }else{
                operateType.push({title:"取消关联选题",onClick:() => {
                    this.cancelTopicSelection(item)
                }})
            }
        }
        if(submitStatusName == '已发布'){
            operateType.push({title:"已采用媒体",onClick:() => {this.submitMedia(item)}})
        }
            return(
                <div style={{display: 'flex', float: 'right'}}>{
                     operateType.map((items,index)=>{
                         if(items.title==="下载稿件"){
                             return(
                                <div key={index} id="downloadmenu" style={{
                                    fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"
                                }} onClick={items.onClick}>
                                    <Dropdown overlay={this.getMenu(item)} arrow placement="bottomCenter" getPopupContainer={() => document.getElementById('downloadmenu')}><b>下载稿件</b></Dropdown>
                                </div>
                             )
                         }
                         if(items.title==="拾取至"){
                            let wzList  = [];
                            let wxList = [];
                            this.state.popoverList.map((popItem, popIndex) => {
                                //目前只拾取至网站和微信
                                if (mediaCodes.indexOf(popItem.code) > -1) {
                                    if (/*popItem.copyStorys.length === 0 &&*/( popItem.type === 1||popItem.type === 2)) {
                                        if(popItem.type === 1){ //网站
                                            wzList.push(popItem)
                                        } else if(popItem.type === 2){ //微信
                                            wxList.push(popItem)
                                        }
                                    }
                                }
                            })
                             return(
                                <Popover key={index} content={<div
                                        style={{height: 180, overflowY: 'auto',overflowX:"hidden"}}
                                    >
                                        {
                                            wzList.length > 0 ?
                                                <div style={{ display: 'flex', flexDirection:'column'}}>
                                                    <span style={{ padding: 5}}>网站</span>
                                                    {
                                                        wzList.map((popItem, popIndex) => (
                                                            <span title={popItem.name} style={{ padding: '5px 5px 5px 25px', cursor: 'pointer',width:"160px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} onClick={() => {
                                                                this.state.dataList[i].checked = false;
                                                                this.setState({});
                                                                this.pickTo(item, popItem)
                                                            }}
                                                                key={popIndex}>{popItem.name}</span>
                                                        ))
                                                    }
                                                </div> : null
                                                
                                       }
                                       {
                                           wxList.length > 0 ?
                                           <div style={{ display: 'flex', flexDirection:'column'}}>
                                               <span style={{ padding: 5}}>微信</span>
                                               {
                                                   wxList.map((popItem, popIndex) => (
                                                       <span title={popItem.name} style={{ padding: '5px 5px 5px 25px',  cursor: 'pointer',width:"160px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} onClick={() => {
                                                           this.state.dataList[i].checked = false;
                                                           this.setState({});
                                                           this.pickTo(item, popItem)
                                                       }}
                                                           key={popIndex}>{popItem.name}</span>
                                                   ))
                                               }
                                           </div> :null
                                       }
                                    </div>
                                    } placement="bottom"
                                                                     title={null}
                                                                     onVisibleChange={() => {
                                                                         item.checked = false;
                                                                         this.setState({})
                                                                     }}
                                                                     visible={item.checked}>
                                        <div className={'customBtn'} style={{
                                            fontsize: 15,
                                            color: newSecondSelectColor,
                                            cursor: 'pointer',
                                            paddingLeft: 10,
                                            paddingRight: 10
                                        }} onClick={() => {
                                            this.getCopyStoryMediaConllection(item);
                                        }}><b>拾取至</b></div>
                                    </Popover>
                             )
                         }
                         if(operateType.length>4){
                             let element=operateType.splice(3)
                             operateType.push({
                                 title:"更多操作",
                                 onClick:this.getMoreMenu(element)
                             })
                         }
                              if(items.title==="更多操作"){
                                     return(
                                        <div id="downloadMoremenu" key={index} style={{fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"}}>
                                            <Dropdown overlay={items.onClick} arrow placement="bottomCenter" getPopupContainer={() => document.getElementById('downloadMoremenu')}><b>更多操作</b></Dropdown>
                                        </div>
                                     )
                                 }
                        return(<div key={index} style={{
                            fontsize: 15, color: newSecondSelectColor,cursor: 'pointer',marginRight:"10px"
                        }} onClick={items.onClick}>{items.title}</div>)                  
                })
                }                   
                </div>                                                               
            )
    }

    render() {
        let height = window.innerHeight - HEADER_HEIGHT;//上部分70//
        let newSecondSelectColor = this.props.config && this.props.config.getValueByKey ? this.props.config.getValueByKey("newSecondSelectColor", '#0050B3') : '#0050B3';
        //this.state.topRedNum = 100;
        let topRedNum = this.state.topRedNum;
        if (topRedNum > 99) {
            topRedNum = '(99+)';
        } else {
            topRedNum = '(' + topRedNum + ')';
        }

        let typeList = [
            {
                title: '类别',
                value: 'type',
                key: 'type',
                disabled: true,
                children: [
                    {
                        title: '所有稿件',
                        value: '1',
                        key: '1',
                        children: []
                    },
                    {
                        title: '我创建的',
                        value: '2',
                        key: '2',
                        children: []
                    },
                    {
                        title: <span>待我处理<span
                            style={{color: '#ff5b57'}}>&nbsp;{(this.state.topRedNum > 0 ? topRedNum : '')}</span> </span>,
                        value: '3',
                        key: '3',
                        children: []
                    },
                ],
            },
            {
                title: '状态',
                value: 'status',
                key: 'status',
                disabled: true,
                children: [
                    {
                        title: '草稿',
                        value: '4',
                        key: '4',
                        children: []
                    },
                    {
                        title: '审核中',
                        value: '5',
                        key: '5',
                        children: []
                    },
                    {
                        title: '已发布',
                        value: '6',
                        key: '6',
                        children: []
                    }, {
                        title: '已弃用',
                        value: '7',
                        key: '7',
                        children: []
                    },
                ],
            },
        ];
        //强行改变按钮的而文字
        if (this.state.typeKey === '3') {
            typeList[0].children[2].title = '待我处理';
        } else {
            typeList[0].children[2].title = <span>待我处理<span
                style={{color: '#ff5b57'}}>&nbsp;{(this.state.topRedNum > 0 ? topRedNum : '')}</span> </span>;
        }
        //稿件池加下分页150，写稿按钮行 50

        //取出当前用户
//        console.log(this.props.currentUser)
        let account = this.props.currentUser.account;
        let mediaCodes = this.props.currentUser.mediaCodes;
        let wzList  = [];
        let wxList = [];
        this.state.popoverList.map((popItem, popIndex) => {
            //目前只拾取至网站和微信
            if (mediaCodes.indexOf(popItem.code) > -1) {
                if (/*popItem.copyStorys.length === 0 &&*/( popItem.type === 1||popItem.type === 2)) {
                    if(popItem.type === 1){ //网站
                        wzList.push(popItem)
                    } else if(popItem.type === 2){ //微信
                        wxList.push(popItem)
                    }
                }
            }
        })

        return (
            <div style={{height: height,}}>
                <div style={{display: 'flex', background: '#ffffff',justifyContent:"space-between",alignItems:"center"}}>
                    <b style={{
                        color: newSecondSelectColor,
                        fontSize: 18,
                        paddingBottom: 20,
                        height: 58,
                        lineHeight: '58px',
                        marginLeft: 20
                    }}>
                        稿件池
                    </b>
                    {/*  <div className={'card-container'} style={{margin: 'auto', marginTop: 18}}>
                        <Tabs defaultActiveKey={this.state.selectKey} type="card" activeKey={this.state.selectKey}
                              onChange={(key) => {
                                  this.state.page = 1;
                                  this.state.size = 10;
                                  // this.state.selectKey = key;
                                  // this.setState({})
                                  //  this.TypeChange();
                              }} tabBarGutter={0}>
                            <TabPane tab={"原创稿件"} key={'1'}></TabPane>
                            <TabPane tab={"投稿稿件"} key={'2'}></TabPane>
                            <TabPane tab={"其他媒体稿件"} key={'3'}></TabPane>
                        </Tabs>
                        <style>
                            {`
                          
            
            .card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab-active {
              color:${newSecondSelectColor}!important ;
              font-weight:bold;
             font-size:16px !important;
                }
                  .card-container  .ant-tabs-nav-container  {
             font-size:16px !important;
                }
                .card-container >.ant-tabs.ant-tabs-card .ant-tabs-card-bar .ant-tabs-tab-active{
                 background:#f2f2f2 !important;
                 border-top-left-radius: 10px;
                  border-top-right-radius: 10px;
                }
                 .card-container > .ant-tabs-card > .ant-tabs-bar .ant-tabs-tab {
             font-weight:bold;
             background:white !important;
             border:none;
             color:#6c748b
            }
             .card-container >  .ant-tabs-nav .ant-tabs-tab:hover {
                color: ${newSecondSelectColor} !important;
            }
                             `}
                        </style>
                    </div>*/}
                    <table border="0" cellPadding="0" cellSpacing="0" width={70} height={58}> 
                        <tbody>
                            <tr>
                                <td valign={"middle"}>
                                    <style>
                                        {`
                                            .tableChangeBtn {
                                                width:25px;height:25px;cursor:pointer;
                                            }
                                        `}
                                    </style>
                                    <img onClick={this.checkedList} className={"tableChangeBtn"} src={this.state.listChecked?card:otherCard} title={"列表模式"} alt="列表模式"/>
                                    <img onClick={this.checkedCard} className={"tableChangeBtn"} src={this.state.cardChecked?list:otherList} title={"卡片模式"} alt="卡片模式"/>
                                </td>
                            </tr>
                        </tbody>
                    </table>   
                </div>

                <div style={{paddingLeft: 20, paddingRight: 20}}>

                    <div style={{marginTop: 20, background: '#f2f2f2', paddingBottom: 10}}>
                        <Button type="primary" style={{
                            float: 'left',
                            background: newSecondSelectColor,
                            borderColor: newSecondSelectColor
                        }} onClick={() => {
                            this.add()
                        }}>写稿</Button>
                        <Button
                            style={{marginLeft: 20, float: 'left',  borderColor: newSecondSelectColor, color: newSecondSelectColor }} onClick={() => {
                            this.SelectManuscriptPool.showTask({taskTitle: '关联任务', topBtn: true})
                        }}>关联任务</Button>
                        <Button style={{marginLeft: 20,  borderColor: newSecondSelectColor,  color: newSecondSelectColor}} onClick={() => {
                            this.SelectManuscriptPool.showTask({taskTitle: '关联选题', topBtn: true})
                        }}
                        >关联选题</Button>
                        <div style={{float: 'right', width: 400, display: 'flex'}}>
                            <div style={{width: 200, position: 'relative'}}>
                                <TreeSelect
                                    /* showSearch*/
                                    style={{width: '100%', paddingLeft: 10,fontSize:16,color:'#a4adc8'}}
                                    value={this.state.typeKey}
                                    dropdownStyle={{maxHeight: 400, overflow: 'auto'}}
                                    placeholder="请选择"
                                    treeDefaultExpandAll
                                    treeData={typeList}
                                    onChange={(value) => {
                                        this.state.typeKey = value;
                                        this.state.page = 1;
                                        this.state.size = 10;
                                        this.setState({});
                                        this.TypeChange();
                                    }
                                    }
                                />
                                {
                                    this.state.topRedNum > 0 ? <div style={{
                                        width: 31,
                                        height: 16,
                                        background: '#ff5b57',
                                        color: 'white',
                                        position: 'absolute',
                                        top: -10,
                                        right: -10,
                                        fontSize: 12,
                                        textAlign: 'center',
                                        borderRadius: '8px',
                                        lineHeight: '16px',
                                        cursor: 'pointer',
                                    }} onClick={() => {
                                        this.state.typeKey = '3';
                                        this.state.page = 1;
                                        this.state.size = 10;
                                        this.setState({});
                                        this.TypeChange();
                                    }}>{this.state.topRedNum < 100 ? this.state.topRedNum : '99+'}
                                    </div> : null
                                }
                            </div>
                            <div style={{marginLeft: 20,}}>
                                <Search
                                    placeholder="请输入搜索内容"
                                    onSearch={value => this.onSearch(value)}
                                    value={this.state.searchValue}
                                    onChange={(e) => {
                                        this.setState({
                                            searchValue: e.target.value
                                        })
                                    }}
                                    style={{width: 200}}
                                />
                            </div>

                        </div>

                    </div>
                    <div style={{height: height - 176, background: 'white'}}>
                        <Scrollbars ref={Scrollbars=>this.scrollRef=Scrollbars}>
                            {
                                this.state.isShow===true&&this.state.dataList.length === 0 ? <Empty/> : null
                            }
                            {
                                this.state.showType==="list"?
                                <ManuscriptTable dataList={this.state.dataList}
                                newSecondSelectColor={newSecondSelectColor}
                                titleClick={(item) => {
                                    this.itemTitleClick(item)
                                }}
                                task1Click={(item) => {
                                    if (item.interviewId) {
                                        this.RelationTaskDetail.taskDetailShow(item.interviewId);
                                    }
                                }}
                                task2Click={(item) => {
                                    if ( item.topicSelectionId) {
                                        this.RelationSelectTopicDetail.selectTopicDetailDetailShow(item.topicSelectionId);
                                    }
                                }}
                                btn=
                                    {
                                        (submitStatusName, item, newSecondSelectColor,i)=>this.renderBtn(submitStatusName, item, newSecondSelectColor,i)
                                    }
                                showType={"manuscriptPool"}
                                />:
                                this.state.dataList.map((item, i) => {
                                    let submitStatusName = '';
                                    if (item.copyStorys.length > 0) {
                                        item.copyStorys.forEach(copyStoryItem => {
                                            if (copyStoryItem.statusName === '发布') {
                                                submitStatusName = '已发布';
                                                return;
                                            }
                                        });
                                        if (submitStatusName !== '已发布') {
                                            if (item.statusName === '发布') {
                                                submitStatusName = '已发布';
                                            } else {
                                                submitStatusName = item.statusName;
                                            }
                                        }
                                    } else {
                                        if (item.statusName === '发布') {
                                            submitStatusName = '已发布';
                                        } else {
                                            submitStatusName = item.statusName;
                                        }
                                    }

                                    let sex = item.submitUser&&item.submitUser.sex?item.submitUser.sex:1;
                                    if (this.props.currentUser)
                                        sex = this.props.currentUser.sex;
                                    let photo = "images/header_boys.png";
                                    /* if (this.props.currentUser && this.props.currentUser.photoUrl && this.props.currentUser.photoUrl.length > 0) {
                                         photo = this.props.currentUser.photoUrl
                                     } else {*/
                                    if (sex === 2) {
                                        photo = "/cm-sites/images/header_girls.png";
                                    }
                                    // }

                                    return (
                                        <ManuscriptPoolItem key={i} newSecondSelectColor={newSecondSelectColor}
                                                            title={item.title}
                                                            submitStatusName={submitStatusName}
                                                            submitTime={''}
                                                            createTime={item.submitDate && item.submitDate.time ? utils.formatDate(item.submitDate.time) : ''}
                                                            changeTime={item.changeDate && item.changeDate.time ? utils.formatDate(item.changeDate.time) : ''}
                                                            mark={item.summary}
                                                            task1={item.interview && item.interview.id ? item.interview.title : ''}
                                                            task2={item.topicSelection && item.topicSelection.id ? item.topicSelection.tsName : ''}
                                                            name={item.submitUser ? item.submitUser.name : ''}
                                                            titlePic={item.titlePic}
                                                            userPic={item.submitUser && item.submitUser.photoUrl ? item.submitUser.photoUrl : photo}
                                                            titleClick={() => {
                                                                this.itemTitleClick(item)
                                                            }}
                                                            task1Click={() => {
                                                                if (item.interviewId) {
                                                                    this.RelationTaskDetail.taskDetailShow(item.interviewId);
                                                                }
                                                            }}
                                                            task2Click={() => {
                                                                if (item.topicSelectionId) {
                                                                    this.RelationSelectTopicDetail.selectTopicDetailDetailShow(item.topicSelectionId)
                                                                }
                                                            }}
                                                            btn={<div style={{display: 'flex', float: 'right'}}>

                                                                {
                                                                    submitStatusName == '已发布' ? <div className={'customBtn'} style={{
                                                                        fontsize: 15,
                                                                        color: '#6c748b',
                                                                        cursor: 'pointer',
                                                                        paddingRight: 10
                                                                    }} onClick={() => {
                                                                        this.submitMedia(item)
                                                                    }}><b>已采用媒体</b></div> : null
                                                                }
                                                                <div className={'customBtn'} style={{
                                                                            fontsize: 15,
                                                                            color: '#6c748b',
                                                                            cursor: 'pointer',
                                                                            paddingLeft: 10,
                                                                            paddingRight: 10
                                                                        }} onClick={() => {
                                                                            window.open(`/cm-sites/pms/printHtmlDetail.html?resourceId=${item.resourceId}`,'_blank');
                                                                        }}><b>打印</b></div>

                                                                    <div className={'customBtn'} style={{
                                                                            fontsize: 15,
                                                                            color: '#6c748b',
                                                                            cursor: 'pointer',
                                                                            paddingLeft: 10,
                                                                            paddingRight: 10
                                                                        }} onClick={() => {
                                                                        this.review(item)
                                                                        }}><b>预览</b></div>

                                                                {
                                                                    mediaCodes.length > 0 &&(submitStatusName==='提交至拟发平台'||submitStatusName==='审核通过'||submitStatusName==='提交至媒体'|| submitStatusName === '已发布')? <Popover content={<div
                                                                        style={{height: 180, overflow: 'auto'}}
                                                                    >
                                                                        {
                                                                            wzList.length > 0 ?
                                                                                <div style={{ display: 'flex', flexDirection:'column'}}>
                                                                                    <span style={{ padding: 5}}>网站</span>
                                                                                    {
                                                                                        wzList.map((popItem, popIndex) => (
                                                                                            <span title={popItem.name} style={{ padding: '5px 5px 5px 25px',  cursor: 'pointer',width:"160px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} onClick={() => {
                                                                                                this.state.dataList[i].checked = false;
                                                                                                this.setState({});
                                                                                                this.pickTo(item, popItem)
                                                                                            }}
                                                                                                key={popIndex}>{popItem.name}</span>
                                                                                        ))
                                                                                    }
                                                                                </div> : null
                                                                                
                                                                       }
                                                                       {
                                                                           wxList.length > 0 ?
                                                                           <div style={{ display: 'flex', flexDirection:'column'}}>
                                                                               <span style={{ padding: 5}}>微信</span>
                                                                               {
                                                                                   wxList.map((popItem, popIndex) => (
                                                                                       <span title={popItem.name} style={{ padding: '5px 5px 5px 25px',  cursor: 'pointer',width:"160px",overflow:"hidden",textOverflow:"ellipsis",whiteSpace:"nowrap"}} onClick={() => {
                                                                                           this.state.dataList[i].checked = false;
                                                                                           this.setState({});
                                                                                           this.pickTo(item, popItem)
                                                                                       }}
                                                                                           key={popIndex}>{popItem.name}</span>
                                                                                   ))
                                                                               }
                                                                           </div> :null
                                                                       }
                                                                    </div>
                                                                    } placement="bottom"
                                                                                                     title={null}
                                                                                                     onVisibleChange={() => {
                                                                                                         item.checked = false;
                                                                                                         this.setState({})
                                                                                                     }}
                                                                                                     visible={item.checked}>
                                                                        <div className={'customBtn'} style={{
                                                                            fontsize: 15,
                                                                            color: '#6c748b',
                                                                            cursor: 'pointer',
                                                                            paddingLeft: 10,
                                                                            paddingRight: 10
                                                                        }} onClick={() => {
                                                                           // this.state.dataList[i].checked = true;
                                                                            this.getCopyStoryMediaConllection(item);
                                                                        }}><b>拾取至</b></div>
                                                                    </Popover> : null
                                                                }


                                                                {
                                                                    account === item.submitter && (item.statusName === '草稿' || item.statusName === '弃用') ?
                                                                        <Popconfirm
                                                                            title="请确认是否删除稿件"
                                                                            onConfirm={() => {
                                                                                this.deleteItem(item)
                                                                            }}
                                                                            onCancel={() => {
                                                                            }}
                                                                            okText="确认"
                                                                            cancelText="取消"
                                                                        >
                                                                            <div className={'customBtn'} style={{
                                                                                fontsize: 15,
                                                                                color: '#6c748b',
                                                                                cursor: 'pointer',
                                                                                paddingLeft: 10,
                                                                                paddingRight: 10
                                                                            }}><b>删除</b></div>
                                                                        </Popconfirm>
                                                                        : null
                                                                }
                                                                {account === item.submitter && (item.interviewId === 0 ) ? (item.statusName === '审核未通过' || item.statusName === '弃用'||item.statusName === '审核通过' ?null:
                                                                    <div className={'customBtn'} style={{
                                                                        fontsize: 15,
                                                                        color: '#6c748b',
                                                                        cursor: 'pointer',
                                                                        paddingLeft: 10,
                                                                        paddingRight: 10
                                                                    }} onClick={() => {
                                                                        this.setState({currentItemClick: item});
                                                                        this.SelectManuscriptPool.showTask({
                                                                            taskTitle: '关联任务',
                                                                            topBtn: false
                                                                        })
                                                                    }}><b>关联任务</b></div>) :null }
                                                                {account === item.submitter && (item.statusName === '草稿' || item.statusName === '弃用') &&(item.interviewId > 0 )?
                                                                <Popconfirm
                                                                        title="请确认是否取消关联任务"
                                                                        onConfirm={() => {
                                                                            this.cancelTaask(item)
                                                                        }}
                                                                        onCancel={() => {
                                                                        }}
                                                                        okText="确认"
                                                                        cancelText="取消"
                                                                    >
                                                                        <div className={'customBtn'} style={{
                                                                            fontsize: 15,
                                                                            color: '#6c748b',
                                                                            cursor: 'pointer',
                                                                            paddingLeft: 10,
                                                                            paddingRight: 20
                                                                        }}><b>取消关联任务</b></div>
                                                                    </Popconfirm> : null}


                                                                {
                                                                    account === item.submitter&&(item.statusName !== '弃用') /*&& (item.statusName === '草稿' || item.statusName === '弃用')*/ ? (item.topicSelectionId === 0 ?
                                                                        <div className={'customBtn'} style={{
                                                                            fontsize: 15,
                                                                            color: '#6c748b',
                                                                            cursor: 'pointer',
                                                                            paddingLeft: 10,
                                                                            paddingRight: 10
                                                                        }} onClick={() => {
                                                                            this.setState({currentItemClick: item});
                                                                            this.SelectManuscriptPool.showTask({
                                                                                taskTitle: '关联选题',
                                                                                topBtn: false
                                                                            })
                                                                        }}><b>关联选题</b></div> :
                                                                        <Popconfirm
                                                                            title="请确认是否取消关联选题"
                                                                            onConfirm={() => {
                                                                                this.cancelTopicSelection(item)
                                                                            }}
                                                                            onCancel={() => {
                                                                            }}
                                                                            okText="确认"
                                                                            cancelText="取消"
                                                                        >
                                                                            <div className={'customBtn'} style={{
                                                                                fontsize: 15,
                                                                                color: '#6c748b',
                                                                                cursor: 'pointer',
                                                                                paddingLeft: 10,
                                                                                paddingRight: 20
                                                                            }}><b>取消关联选题</b></div>
                                                                        </Popconfirm>) : null
                                                                }

                                                                <div className={'customBtn'} id="downloadmenu" style={{
                                                                    fontsize: 15,
                                                                    color: '#6c748b',
                                                                    cursor: 'pointer',
                                                                    paddingLeft: 10,
                                                                    paddingRight: 20
                                                                }} onClick={() => {
                                                                    
                                                                }}>  <Dropdown overlay={this.getMenu(item)} arrow placement="bottomCenter" getPopupContainer={() => document.getElementById('downloadmenu')}><b>下载稿件</b></Dropdown></div>
                                                                <style>{`
                                                    .customBtn :hover{
                                                    color:${newSecondSelectColor}
                                                    }
                                                    
                                                    `} </style>
                                                            </div>}
                                        />
                                    )
                                })
                            }

                        </Scrollbars>
                    </div>

                </div>

                <div style={{padding: 10, float: 'right'}}>
                    <Pagination
                        showQuickJumper
                        // defaultCurrent={2}
                        current={this.state.page}
                        pageSize={this.state.size}
                        total={this.state.listTotal}
                        showTotal={total => `共 ${total} 条`}
                        showSizeChanger
                        onChange={(page, pageSize) => this.onChange(page, pageSize)}
                        onShowSizeChange={(page, pageSize) => {
                            this.onChange(page, pageSize)
                        }}
                    />
                </div>
                <SelectManuscriptPool newSecondSelectColor={newSecondSelectColor}
                                      ref={SelectManuscriptPool => this.SelectManuscriptPool = SelectManuscriptPool}
                                      callBack={(data) => {
                                          console.log(data)
                                          if (data.topBtn) {
                                              if (data.taskTitle === '关联任务') {
                                                  this.topTask(data)
                                              } else {
                                                  this.topChooseTopic(data)
                                              }
                                          } else {
                                              if (data.taskTitle === '关联任务') {
                                                  this.itemTask(data)
                                              } else {
                                                  this.itemChooseTopic(data)
                                              }
                                          }
                                      }}/>
                <PublishedMedia newSecondSelectColor={newSecondSelectColor}
                                ref={PublishedMedia => this.PublishedMedia = PublishedMedia}/>
                <RelationTaskDetail ref={RelationTaskDetail => this.RelationTaskDetail = RelationTaskDetail}/>
                <RelationSelectTopicDetail
                    ref={RelationSelectTopicDetail => this.RelationSelectTopicDetail = RelationSelectTopicDetail}/>

            </div>
        )
    }


    onChange(page, pageSize) {
        this.state.page = page;
        this.state.size = pageSize;
        this.TypeChange()

    }

    //标题点击预览
    itemTitleClick(item) {
        console.log(item)
        let url;//1原创稿件，2，投稿稿件，3.其他们提，
        if (this.state.selectKey === '1') {
            if (item.interviewId) {
                url = '/cm-sites/pms/addContribute/addContributeNews.html?eiditStoryId=' + item.id + '&interviewId=' + item.interviewId + '&actButtonId=9&isShowMainColumnSetBtn=false&passMediaCodes=' + (item.interview.mediaCodes ? item.interview.mediaCodes.toString() : '')
            } else {
                url = "/cm-sites/pms/addContribute/addContributeNews.html?interviewId=" +item.interviewId + "&attribute=original&actButtonId=30&isShowMainColumnSetBtn=false&eiditStoryId=" + item.id;
            }
        }/* else if (this.state.selectKey === '2') {
            url = "/cm-sites/pms/addContribute/addContributeNews.html?attribute=original";
        } else if (this.state.selectKey === '3') {
            url = "/cm-sites/pms/addContribute/addContributeNews.html?attribute=original";
        }*/

        let that = this;
        window.openFull(url, "编辑稿件", null, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, null, function () {
            that.TypeChange();
        })
    }

    //获取已发布，拾取至的数据
    getCopyStoryMediaConllection(item) {
        let body = {
            storyId: item.id
        };
        let list = [];
        this.actions.getCopyStoryMediaConllection(body, data => {
            if (data && data.data) {
                list = data.data;
                item.checked=true;
            }
            this.setState({
                popoverList: list,
            });
        })
    }

    //点击已采用媒体
    submitMedia(item) {
        let body = {
            storyId: item.id
        };
        let list = [];
        this.actions.getCopyStoryMediaConllection(body, data => {
            if (data && data.data) {
                list = data.data;
            }
            list.forEach(Item => {
                if (item.mediaCode === Item.code) {
                    Item.copyStorys.push(item)
                }
            });
            this.PublishedMedia.publishMediaSow(list)
        })


    }

    //拾取至网站和公众号
    pickTo(item, popItem) {
        console.log(item,popItem,this.state.selectKey)
        if(popItem.type===1){
            let url;
            if (this.state.selectKey === '1') {
                url = "/cm-sites/pms/addContribute/addContributeNews.html?attribute=copyFromOriginal&copyType=story&srcId=" + item.id + '&actButtonId=2&currentMediaCode=' + popItem.code;
            } /*else if (this.state.selectKey === '2') {
            url = "/cm-sites/pms/addContribute/addContributeNews.html?attribute=original";
        } else if (this.state.selectKey === '3') {
            url = "/cm-sites/pms/addContribute/addContributeNews.html?attribute=original";
        }*/
            console.log(url);
            let that = this;
            window.openFull(url, "新建稿件", null, {
                shade: 0.5,
                area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
            }, null, function () {
                that.TypeChange();
            })
        }else  if(popItem.type===2){
            item.newType=1;
        let parms={mediaCode:popItem.code,data:[{type:1,id:item.id}]};
            Actions.addToEditor(parms,(res) => {
                if(res.state){
                    //this.props.history.push('/view/WeChatPublish/'+popItem.code)
                    this.goPublish(popItem.code);
                }else {
                    message.error('未查询到！')
                }
            })
        }
    }

    findUrlData = (url) => {
        let sons;
        let name;
        let stopFind = false;
        let find = (data, level, levelOneBrothers, levelOneName) => {
            if (stopFind)
                return;
            if ((!data.sons || data.sons.length === 0) && (!data.float_ || data.float_.length === 0)) {
                if (data.path === url) {
                    sons = levelOneBrothers;
                    name = levelOneName;
                    stopFind = true;
                }
                return;
            }
            let tempSons = data.float_;
            if (!tempSons || tempSons.length === 0) {
                tempSons = data.sons;
            }
            if (stopFind)
                return;
            tempSons && tempSons.map(item => {
                if (stopFind)
                    return;
                let tempItemSons = item.float_;
                if (!tempItemSons || tempItemSons.length === 0) {
                    tempItemSons = item.sons;
                }
                if (level == 0) {//取第一级的信息
                    find(item, level + 1, tempItemSons, item.name);
                } else {
                    find(item, level + 1, levelOneBrothers, levelOneName);
                }
            })
        };
        find({sons: this.props.navigateData}, 0, null, null);
        return {stopFind, sons, name};
    };

    goPublish = (mediaCode) => {
        // let {stopFind, sons, name} = this.findUrlData('/view/weChatPublish/'+ mediaCode);//window.location.hash='#/view/weChatPublish/BaijHao'
        // console.log(mediaCode);
        // console.log('/view/weChatPublish/' + mediaCode)
        // if (stopFind) {
        //     this.props.shrinNavigateStauts();
        //     this.props.updateNavigateLevel2Data(name, sons);
        //     this.props.history.push('/view/weChatPublish/'+ mediaCode)  
        //     return;
        // }

        let {stopFind, sons, name} = this.findUrlData('/view/weChatPublish/'+ mediaCode);
        if (stopFind) {
            this.props.shrinNavigateStauts();
            this.props.updateNavigateLevel2Data(name, sons);
            this.props.navigateData.forEach(item=>{
                if(item.name===name){
                    item.check=true;
                    item.status="down"
                }else {
                    item.check=false;
                    item.status="up"
                }
            });
            this.props.updataNavigateData( this.props.navigateData);
            window.location.hash = '/view/weChatPublish/'+ mediaCode;
            return;
        }
    }

    //写稿
    add() {
        let url;//1原创稿件，2，投稿稿件，3.其他们提，
        if (this.state.selectKey === '1') {
            url = "/cm-sites/pms/addContribute/addContributeNews.html?attribute=original&actButtonId=30&isShowMainColumnSetBtn=false";
        }/* else if (this.state.selectKey === '2') {
            url = "/cm-sites/pms/addContribute/addContributeNews.html?attribute=original";
        } else if (this.state.selectKey === '3') {
            url = "/cm-sites/pms/addContribute/addContributeNews.html?attribute=original";
        }*/
        console.log(url);
        let that = this;
        window.openFull(url, "新建稿件", null, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, null, function () {
            that.TypeChange();
        })
    }

    //搜索
    onSearch(value) {
        this.state.searchValue = value;
        this.state.page = 1;
        this.state.size = 10;
        this.TypeChange();
    }

    //顶部关联任务
    topTask(data) {
        let url;//1原创稿件，2，投稿稿件，3.其他们提， //interviewId
        if (this.state.selectKey === '1') {
            url = " /cm-sites/pms/addContribute/addContributeNews.html?attribute=original&eiditStoryId=0&interviewId=" + (data.id ? data.id : 0) + "&actButtonId=9&isShowMainColumnSetBtn=false&passMediaCodes=" + data.mediaCodes.toString();
        }
        console.log(url);
        let that = this;
        window.openFull(url, "新建稿件", null, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, null, function () {
            that.TypeChange();
        })
    }

    //顶部选题
    topChooseTopic(data) {
        let url;//1原创稿件，2，投稿稿件，3.其他们提，
        if (this.state.selectKey === '1') {
            url = "/cm-sites/pms/addContribute/addContributeNews.html?attribute=original&actButtonId=30&isShowMainColumnSetBtn=false&topicSelectionId=" + data.id;
        }
        console.log(url);
        let that = this;
        window.openFull(url, "新建稿件", null, {
            shade: 0.5,
            area: [parseInt(window.document.body.clientWidth * 0.9) + 'px', parseInt(window.document.body.clientHeight * 0.9) + 'px']
        }, null, function () {
            that.TypeChange();
        });
    }

    //每一项的关联任务
    itemTask(data) {
        let currentItemClick = this.state.currentItemClick;
        let body = {
            storyId: currentItemClick.id,//稿件id
            bindId: data.id,//选题id
            type: 'interview',
            isbind: true//绑定还是解绑
        };
        this.actions.originalStoryBindOrUnbind(body, data => {
            this.TypeChange();//刷新列表
        });
    }

    //每一项的关联选题
    itemChooseTopic(data) {
        let currentItemClick = this.state.currentItemClick;
        let body = {
            storyId: currentItemClick.id,//稿件id
            bindId: data.id,//选题id
            type: 'topicSelection',
            isbind: true//绑定还是解绑
        };
        this.actions.originalStoryBindOrUnbind(body, data => {
            this.TypeChange();//刷新列表
        });
    }

    //删除稿件
    deleteItem(item) {
        let body = {
            storyId: item.id,
        };
        this.actions.delStoryById(body, data => {
            if (data) {
                message.info('删除成功')
                this.TypeChange();//刷新列表
            }
        })
    }

    //取消关联任务
    cancelTaask(item) {
        let body = {
            storyId: item.id,//稿件id
            bindId: item.interviewId,//选题id
            type: 'interview',
            isbind: false//绑定还是解绑
        };
        this.actions.originalStoryBindOrUnbind(body, data => {
            if(data.status){
                this.TypeChange();//刷新列表
            }else {
                message.info(data.msg)
            }

        });
    }

    //取消关联选题
    cancelTopicSelection(item) {
        let body = {
            storyId: item.id,//稿件id
            bindId: item.topicSelectionId,//选题id
            type: 'topicSelection',
            isbind: false//绑定还是解绑
        };
        this.actions.originalStoryBindOrUnbind(body, data => {
            if(data.status){
                this.TypeChange();//刷新列表
            }else {
                message.info(data.msg)
            }
        });
    }

    //下载稿件
    itemDownload(item) {
        let body = {
            storyId: item.id,
        };
        this.actions.downloadStoryById(body, data => {
            window.open(data)
        })
    }


    //预览
    review(item){
        if(item.linkurl){
            window.open(item.linkurl,'_blank');
        }else{
            window.open('/cm-sites/pms/framereact/index.html?#/preview/page/'+item.id+'/1','_blank');
        }
    }

}

function mapStateToProps(state) {
    return {
        config: state.systemReducer.config,
        currentUser: state.systemReducer.currentUser,
        navigateData: state.systemReducer.navigateData,
    }
}

function mapStateToMethod(dispatch) {
    return {
        shrinNavigateStauts: function () {
            return dispatch(shrinNavigateStauts());
        },
        updateNavigateLevel2Data: function (title, data) {
            return dispatch(updateNavigateLevel2Data(title, data));
        },
        updataNavigateData:function (data) {
              return dispatch(updataNavigateData(data))
        }
    }
}

export default connect(mapStateToProps, mapStateToMethod)(ManuscriptPool);